module.exports = __webpack_public_path__ + "img/cyber-essentials.b641df9.svg";